export default __webpack_public_path__ + "static/cigus-gl-3e0fa93aeded73c4e372a709357a5ffa.svg";